import { useEffect } from 'react';
import { useCurrentProjectId } from '@adsk/alloy-provider';
import { useDataApi } from '@adsk/alloy-helpers';
import { buildCreateProjectCompanyRequest } from '@common/utils';

const useCreateProjectCompany = ({ onSuccess, onError }) => {
  const projectId = useCurrentProjectId();

  const {
    data: createProjectCompanyData,
    error: createProjectCompanyError,
    doFetch: doCreateProjectCompanyFetch,
  } = useDataApi();

  const createProjectCompanyRequest = (companyData) => {
    doCreateProjectCompanyFetch(
      ...buildCreateProjectCompanyRequest(projectId, companyData)
    );
  };

  useEffect(() => {
    if (createProjectCompanyError === null) return;

    onError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createProjectCompanyError]);

  useEffect(() => {
    if (createProjectCompanyData === null) return;

    onSuccess(createProjectCompanyData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createProjectCompanyData]);

  return {
    createProjectCompanyRequest,
  };
};

export default useCreateProjectCompany;
